import styles from '../../style.module.scss';
import useStore from "../../store/store";
import {host} from "../../const/const";
import {useState} from "react";

const SummaryPromoCode = ({car}) => {
    const promoCode = useStore((state) => state.promoCode);
    const isApplyPromoCode = useStore((state) => state.isApplyPromoCode);
    const setPromoCode = useStore((state) => state.setPromoCode);
    const setPromoCodeSale = useStore((state) => state.setPromoCodeSale);
    const setIsApplyPromoCode = useStore((state) => state.setIsApplyPromoCode);
    const startDate = useStore((state) => state.startDate);
    const [message, setMessage] = useState('');
    const disabled = () => {
        return !(!!promoCode && promoCode.length >= 3);
    }
    const handleSubmitPromoCode = async () => {
        if (!disabled() && !!car?.carid) {
            const start = `${startDate.getFullYear()}.${startDate.getMonth() + 1}.${startDate.getDate()}`;
            try {
                const response = await fetch(
                    `${host}?action=check_promocode&id=${car.carid}&start=${start}&promocode=${promoCode}`
                ).then((response) => response.json());
                if (response?.message) {
                    setMessage(response.message)
                    setPromoCodeSale(0);
                    setIsApplyPromoCode(false);
                } else {
                    setMessage('');
                }
                if (!!response?.promoCode && !!response?.promoCodeSale) {
                    setPromoCode(response.promoCode);
                    setPromoCodeSale(parseInt(response.promoCodeSale));
                    setIsApplyPromoCode(true);
                }
            } catch (error) {
                console.error(error.message);
                setPromoCodeSale(0);
                setIsApplyPromoCode(false);
            }
        }
    }
    const handleClearPromoCode = async () => {
        try {
            const response = await fetch(
                `${host}?action=remove_promocode`
            ).then((response) => response.json());
        } catch (error) {
            console.error(error.message);
        } finally {
            setPromoCode('');
            setPromoCodeSale(0);
            setIsApplyPromoCode(false);
        }

    }

    return (
        <div className={styles.promoCode}>
            <input type='text' className={`${styles.input} ${isApplyPromoCode && styles.success}`}
                   placeholder='Промокод'
                   onChange={(e) => setPromoCode(e.target.value)} value={promoCode} disabled={isApplyPromoCode}/>
            {
                !isApplyPromoCode && (<button type='button' className={styles.button} disabled={disabled()}
                                              onClick={() => handleSubmitPromoCode()}>Применить
                </button>)
            }
            {
                isApplyPromoCode && (<button type='button' className={styles.button}
                                             onClick={() => handleClearPromoCode()}>Удалить
                </button>)
            }
            {
                !!message && (<div className={styles.message}>{message}</div>)
            }
        </div>
    );
};

export default SummaryPromoCode;